import { WelcomeTitle } from '@backstage/plugin-home';
import AddIcon from '@material-ui/icons/Add';
import ViewModuleOutlinedIcon from '@material-ui/icons/ViewModuleOutlined';
import { FluxButton, FluxPageHeader } from '../flux';
import { Box, makeStyles } from '@material-ui/core';
import { RailwayCostHomeCard } from '@internal/plugin-railway-cost';
import { ToolkitSection } from './ToolkitSection';
import { SystemMetrics } from './SystemMetrics';

const useStyles = makeStyles(theme => ({
  body: { padding: theme.spacing(2.5) },
  grid: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  section: { padding: theme.spacing(2, 0) },
}));

const today = () => {
  const text = new Date().toLocaleDateString('es-CO', {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
  });
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const HomePage = () => {
  const classes = useStyles();
  return (
    <div>
      <FluxPageHeader
        crumbs={[{ label: 'Plataforma' }, { label: 'Home' }]}
        title={<WelcomeTitle language={['Spanish']} />}
        count={today()}
        actions={
          <>
            <FluxButton icon={<ViewModuleOutlinedIcon />} to="/catalog">
              Catálogo
            </FluxButton>
            <FluxButton variant="primary" icon={<AddIcon />} to="/create">
              Create Component
            </FluxButton>
          </>
        }
      />

      <Box className={classes.body}>
        <Box className={classes.grid}>
          <Box className={classes.section}>
            <ToolkitSection />
          </Box>
          <RailwayCostHomeCard />
          <Box className={classes.section}>
            <SystemMetrics />
          </Box>
        </Box>
      </Box>
    </div>
  );
};
